// North America major time zones shared across the apartment + device forms.

export const TIMEZONE_OPTIONS = [
  {label: 'America/New_York', value: 'America/New_York'},
  {label: 'America/Chicago', value: 'America/Chicago'},
  {label: 'America/Denver', value: 'America/Denver'},
  {label: 'America/Los_Angeles', value: 'America/Los_Angeles'},
  {label: 'America/Anchorage', value: 'America/Anchorage'},
  {label: 'Pacific/Honolulu', value: 'Pacific/Honolulu'},
  {label: 'America/Halifax', value: 'America/Halifax'},
  {label: 'America/St_Johns', value: 'America/St_Johns'},
  {label: 'America/Phoenix', value: 'America/Phoenix'},
  {label: 'America/Mexico_City', value: 'America/Mexico_City'},
  {label: 'America/Vancouver', value: 'America/Vancouver'},
  {label: 'America/Winnipeg', value: 'America/Winnipeg'},
  {label: 'America/Toronto', value: 'America/Toronto'},
  {label: 'America/Montreal', value: 'America/Montreal'},
  {label: 'America/Edmonton', value: 'America/Edmonton'},
  {label: 'America/Regina', value: 'America/Regina'},
  {label: 'America/Whitehorse', value: 'America/Whitehorse'},
  {label: 'America/Yellowknife', value: 'America/Yellowknife'},
  {label: 'America/Iqaluit', value: 'America/Iqaluit'},
  {label: 'America/Cancun', value: 'America/Cancun'},
  {label: 'America/Tijuana', value: 'America/Tijuana'},
  {label: 'UTC', value: 'UTC'},
];

export const DEFAULT_TIMEZONE = 'America/New_York';
